export const autoPlayerVideoZIndex = 2
